/**
 * The app version, injected from package.json at build time (see
 * vite.config.ts). One source, so what the side panel shows is always the
 * number that shipped.
 *
 * The native version strings live in android/app/build.gradle and the iOS
 * project file; `appVersion.test.ts` asserts all three agree, because a
 * mismatch there is how a store upload gets rejected.
 */
declare const __APP_VERSION__: string;

export const APP_VERSION: string =
  typeof __APP_VERSION__ === "string" ? __APP_VERSION__ : "0.0.0";
